import { render, staticRenderFns } from "./UnsentEmailReports.vue?vue&type=template&id=a544135e&scoped=true&"
import script from "./UnsentEmailReports.vue?vue&type=script&lang=js&"
export * from "./UnsentEmailReports.vue?vue&type=script&lang=js&"
import style0 from "./UnsentEmailReports.vue?vue&type=style&index=0&id=a544135e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a544135e",
  null
  
)

export default component.exports